import { forwardRef, memo } from 'react'

import styles from './Textfield.module.scss'

type Props = JSX.IntrinsicElements['input'] & {
  hasError?: boolean
}
const TextfieldInner = forwardRef<HTMLInputElement, Props>(
  ({ className = '', hasError, ...props }, ref) => {
    return (
      <div className={`${styles.root} ${className}`} data-in-valid={hasError}>
        <input type="text" ref={ref} {...props} />
      </div>
    )
  },
)

export const Textfield = memo(TextfieldInner)
